export var APP_EVENT_TOKEN_EXPIRED = 'tokenExpired'; // Fields that persist to SFDC have a limit of 255 characters (unless specified)

export var STANDARD_FIELD_LIMIT = 255; // SFDC name fields have a standard limit of 80 characters

export var STANDARD_NAME_FIELD_LIMIT = 80;
export var STANDARD_INPUT_MAX_LENGTH = 2000;